/**
 * Maps a getUserMedia / scanner failure onto a localized message. Without this every
 * failure looks identical to the user: a black box where the preview should be.
 */

const nameOf = (error) =>
  (error && typeof error === "object" && "name" in error && error.name) || "";

const messageOf = (error) =>
  (error && typeof error === "object" && "message" in error && error.message) ||
  "";

export const getCameraErrorMessage = (error, t) => {
  const name = nameOf(error);
  const message = messageOf(error);

  if (name === "NotFoundError" || /Requested device not found/i.test(message)) {
    return t("verify:camera_not_found");
  }

  if (name === "NotAllowedError" || name === "SecurityError") {
    return t("verify:camera_permission_denied");
  }

  if (name === "NotReadableError") {
    return t("verify:camera_in_use");
  }

  return t("verify:camera_start_failed");
};
